import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ZoomOut = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m20 20-3.873-3.873m0 0A7.25 7.25 0 1 0 5.874 5.874a7.25 7.25 0 0 0 10.253 10.253M14.25 11h-6.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 3a8 8 0 1 0 5.102 14.162l3.368 3.369a.75.75 0 1 0 1.06-1.06l-3.368-3.37A8 8 0 0 0 11 3m4 8a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1 0-1.5h6.5A.75.75 0 0 1 15 11'
        fill='currentColor'
      />
    )}
  </IconBase>
);
